<template>
    <div class="line-charts">
        <div id="lineChart" style="width: 200px;margin: 0 auto;height: 50px;"></div>
    </div>
</template>

<script>
var that = null;
var echarts = require('echarts');
export default {
    name: 'lineCharts',
    data() {
        return {
            xAxisData: [],
            series: []
        }
    },
    props: {
        dataList: {
            type: Array,
            default: function () {
                return [];
            }
        },
    },
    mounted() {
        that = this;
        console.log('dataList', that.dataList);
        that.xAxisData = that.dataList.map(item => {
            return item.updateDate;
        })
        that.series = that.dataList.map(item => {
            return item.watchNum;
        })
        that.$nextTick(() => {
            that.setLineEcharts();
        })
    },
    methods: {
        //折线图
        setLineEcharts() {
            let myChart = echarts.init(document.getElementById('lineChart'));
            let option = {
                grid: {
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0
                },
                tooltip: {
                    trigger: 'axis'
                },
                xAxis: {
                    show: false,
                    axisLine: {
                        show: false // 隐藏Y轴线
                    },
                    axisTick: {
                        show: false // 隐藏Y轴刻度线
                    },
                    axisLabel: {
                        show: false // 隐藏Y轴刻度值
                    },
                    type: 'category',
                    boundaryGap: false,
                    data: that.xAxisData
                },
                yAxis: {
                    type: 'value',
                    axisLine: {
                        show: false // 隐藏Y轴线
                    },
                    axisTick: {
                        show: false // 隐藏Y轴刻度线
                    },
                    axisLabel: {
                        show: false // 隐藏Y轴刻度值
                    }
                },
                series: [
                    {
                        data: that.series,
                        type: 'line',
                        areaStyle: {}
                    }
                ]
            };
            myChart.setOption(option);
        },
    }
};
</script>

<style lang='scss' scoped></style>
